import { IContact } from 'clickNgo/entities/contact'
import { getImportantRolesToReassign } from 'clickNgo/features/contact/contactReassignment/lib'

export const getContactsImportantRoles = (contacts: IContact[]) => {
  const roles = Array.from(new Set(contacts.flatMap((contact) => contact.hpRoles)))

  return getImportantRolesToReassign(roles)
}
